import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllCurrencies = () => {
    return axiosInstance({
        url: config.routes.currencies,
        method: 'get',
    });
};

export const fetchActiveCurrencies = () => {
    return axiosInstance({
        url: config.routes.activeCurrencies,
        method: 'get',
    });
};

export const updateCurrencyStatus = (id, cond) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.updateCurrencyStatus(id, cond),
        method: 'put',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};